import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=b4cbc9c2&scoped=true&"
import script from "./CustomDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomDashboard.vue?vue&type=script&lang=js&"
import style0 from "../overview/overview.css?vue&type=style&index=0&lang=css&"
import style1 from "./CustomDashboard.vue?vue&type=style&index=1&id=b4cbc9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbc9c2",
  null
  
)

export default component.exports